.preview-link-button {
  white-space: nowrap;
}
